export default {
	id: 'SIMPLE_UPGRADE_6M_77_95',
	providers: {
		stripe: '',
		braintree: '',
		paltaMap: {
			USD: 'simple_premium_6m_77_95_usd',
			EUR: 'simple_premium_6m_77_95_eur',
			GBP: 'simple_premium_6m_77_95_gbp',
			AUD: 'simple_premium_6m_109_aud',
			CAD: 'simple_premium_6m_109_cad',
			SEK: 'simple_premium_6m_929_sek',
			BRL: 'simple_premium_6m_191_74_brl',
			DKK: 'simple_premium_6m_569_dkk',
			NOK: 'simple_premium_6m_929_nok',
			MXN: 'simple_premium_6m_1259_mxn',
			TRY: 'simple_premium_6m_2699_try',
			ARS: 'simple_premium_6m_103890_ars',
			COP: 'simple_premium_6m_315790_cop',
			CLP: 'simple_premium_6m_75690_clp',
		},
		primer: 'prd_B1HIoBgt3jrV',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 6,
		intro_period_type: 'month',
		next_period_value: 6,
		next_period_type: 'month',
	},
	trial: null,
	subscription: {
		interval: 'month',
		intervalCount: 6,
		priceMap: {
			USD: 77.95,
			EUR: 77.95,
			GBP: 77.95,
			AUD: 109,
			CAD: 109,
			SEK: 929,
			BRL: 191.74,
			DKK: 569,
			NOK: 929,
			MXN: 1259,
			TRY: 2699,
			ARS: 103890,
			COP: 315790,
			CLP: 75690,
		},
	},
	options: ($t) => ({
		barChartTooltip: $t('activity_upgrade.6mo.bar_chart_tooltip'),
		barChartLeftLabel: $t('activity_upgrade.6mo.bar_chart_left_label'),
		barChartRightLabel: $t('activity_upgrade.6mo.bar_chart_right_label'),
	}),
}
